import {
  Layout,
  Col,
  Typography,
  Row,
  Button,
  Form,
  Input,
} from "antd";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import rider from "../../assets/images/rider.png";
import { bindActionCreators } from "redux";
import * as authActions from "../../redux/actions/auth.actions";
import { connect } from "react-redux";
import { useGoogleLogin } from '@react-oauth/google';
import * as types from "../../redux/types/auth.types";
import { useDispatch } from 'react-redux';

const { Title } = Typography;

const Login = ({ navigation, authActions, user, loading, error, user_loading }) => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const dispatch = useDispatch(); 
  const navigate = useNavigate();
  const handleSubmit = async (values) => {
    navigation = navigate;
    await authActions.loginUserAction(
      values.email,
      values.password,
      navigation
    ).then((res) => {
    });
  };

  const onChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const login = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      const res = await fetch(process.env.REACT_APP_K2ACCOUNTS_BASE_URL+'/auth/google/user', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          code: codeResponse.code,
          redirect_uri: codeResponse.redirect_uri,
          system: "rocky"
          // redirect_uri: window.location.origin 
        })
      })
      .then(response => response.json())
      .then(res => {
        dispatch({
          type: types.SET_USER,
          payload: res.data,
        });
        dispatch({
          type: types.SET_TOKEN,
          payload: res.data.token,
        });
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", res.data.name);
        localStorage.setItem("user_id", res.data.id);
        navigate("/overview");
      });
      // Handle response
    },
    onError: (error) => console.error('Login Failed:', error),
    scope: 'openid profile email',
  });

  return (
    <div className="LoginPage">
      <div className="page-content">
        <Row justify="middle" className="CustomLoginRow">
          <Col span={11}>
            <Title level={1} className="formHeading" align="center">
              Welcome to Rocky Back Office
            </Title>
          {/* <Form
              name="login"
              layout="vertical"
              className="loginForm"
              initialValues={{
                remember: true,
              }}
              onFinish={handleSubmit}
              autoComplete="off"
              style={{ maxWidth: "50%", margin: "0 auto" }}
            >
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    type: "email",
                    required: true,
                    message: "Please enter your email!",
                  },
                ]}
              >
                <Input value={credentials.email} onChange={onChange} />
              </Form.Item>
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your password!",
                  },
                ]}
              >
                <Input.Password
                  name="password"
                  value={credentials.password}
                  onChange={onChange}
                />
              </Form.Item>
              <Form.Item
                wrapperCol={{
                  span: 24,
                }}
              >
                <Button type="primary" loading={user_loading} htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form> */}
            <Button onClick={() => login()} style={{display: "block", margin: "10px auto" }}>Login with Google</Button>
          </Col>
          <Col span={2}></Col>
          <Col span={11}>
            <figure>
              <img src={rider} alt="" width="100%" height="auto" />
            </figure>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.user,
    user_loading: state.authReducer.user_loading,
    error: state.authReducer.error,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
